export class CreateMembershipResponseModel {
    id: string;
    constructor(data?: Partial<CreateMembershipResponseModel>) {
        this.id = data?.id || '';
    }
}
